// Modules
import React from 'react';
import { useSelector } from 'react-redux';

// Styles
import { NoResultView, LoadingButton } from './loading.styles';

// Constant
import { constant } from '../../constants/contant';

// Selector
import { capitalizedLang } from '../../selectors/common.selector';

const Loading = () => {
	const lang = useSelector((state: any) => capitalizedLang()(state));
	const dir = useSelector((state: any) => state.common.dir);

	return (
		<NoResultView>
			<LoadingButton 
				direction={dir} 
				label={constant[lang].VARIABLES.LOADING}
			/>
		</NoResultView>
	);
};

export default Loading;
